import { Box, Button, styled, Tooltip } from '@mui/material'

interface SwatchData {
  value: string
}

interface OptionValue {
  uid: string
  hasStock: boolean
  swatch_data?: SwatchData
  label?: string
}

interface ColorOptionItemProps {
  value: OptionValue
  isSelected: boolean
  isDisabled: boolean
  onAction: (uid: string) => void
  trigger?: 'click' | 'hover'
}
const ColorOptionItem = ({
  value,
  isSelected,
  isDisabled,
  onAction,
  trigger = 'hover',
}: ColorOptionItemProps) => {
  const handleInteraction = () => {
    if (!isDisabled && onAction) {
      onAction(value.uid)
    }
  }

  return (
    <Box sx={{ position: 'relative' }}>
      <Tooltip key={value?.uid} title={value?.label} placement="top">
        <ImageButton
          isSelected={isSelected}
          isAvailable={!isDisabled}
          onMouseEnter={() => trigger === 'hover' && handleInteraction()}
          onClick={(e) => {
            e.stopPropagation()
            if (trigger === 'click') handleInteraction()
          }}
        >
          <Box
            sx={{
              width: 'calc(100% - 4px)',
              height: 'calc(100% - 4px)',
              borderRadius: 'inherit',
              backgroundColor: value?.swatch_data?.value,
              border: '1px solid #E9E9E9',
            }}
          />
        </ImageButton>
      </Tooltip>
    </Box>
  )
}
export default ColorOptionItem
const ImageButton = styled(Button, {
  shouldForwardProp: (prop) => !['isSelected', 'isAvailable'].includes(prop as string),
})<{
  isSelected?: boolean
  isAvailable?: boolean
}>(({ theme, isSelected, isAvailable }) => ({
  width: 32,
  height: 32,
  borderRadius: '999px',
  padding: 0,
  overflow: 'hidden',
  pointerEvents: isAvailable ? 'auto' : 'none',
  opacity: isAvailable ? 1 : 0.5,
  transition: 'all 0.2s',
  cursor: isAvailable ? 'pointer' : 'not-allowed',
  border: '1px solid',
  borderColor: !isAvailable ? '#BBBBBA' : isSelected ? theme.palette.primary.main : '#BBBBBA',
  minWidth: 'unset',
  '@media (max-width:600px)': {
    width: 28,
    height: 28,
  },
  '@media (hover: hover)': {
    '&:hover': {
      opacity: 0.5,
    },
  },
}))
